export const fixPagination = async (): Promise<void> => {
  // Only one pagination component exists with this name
  const element = document.getElementsByClassName('n-pagination')[0] as HTMLElement;

  if (!element) {
    return;
  }

  let firstElement = true;

  /* eslint-disable no-param-reassign */
  Array.from(element.children as HTMLCollectionOf<HTMLElement>).forEach((child: HTMLElement) => {
    child.role = 'button';
    child.tabIndex = 0;
    child.addEventListener('keydown', ({ key }) => {
      if (key === 'Enter' || key === ' ') {
        child.click();
      }
    });

    // The pagination components with numbers don't have children, only the end buttons do
    if (child.children.length !== 0) {
      child.children[0].ariaHidden = 'true';
      child.ariaLabel = firstElement ? 'Go Forward' : 'Go Back';
      firstElement = false;
    }
  });
};
